import { toast } from 'ngx-sonner';
import { OperatorFunction, tap } from 'rxjs';
import { RxRequestOptions, OcpToastMessage } from '../../../interfaces';

function showToast(message: OcpToastMessage): void {
  const title = message.summary ?? message.detail ?? '';
  const description = message.summary ? message.detail : undefined;
  switch (message.severity) {
    case 'success':
      toast.success(title, { description, duration: message.life });
      break;
    case 'error':
      toast.error(title, { description, duration: message.life });
      break;
    case 'warn':
      toast.warning(title, { description, duration: message.life });
      break;
    default:
      toast.info(title, { description, duration: message.life });
      break;
  }
}

export function handleRequestSuccess<T>(options?: RxRequestOptions): OperatorFunction<T, T> {
  return tap(() => {
    if (options?.successMessage) {
      showToast(options.successMessage);
    }
  });
}
